webpackJsonp([172928653066618],{

/***/ 175:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(175),
	    identity = __webpack_require__(63);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bar = __webpack_require__(38);
	
	var _constants = __webpack_require__(8);
	
	var _features = __webpack_require__(279);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _nivoTheme = __webpack_require__(20);
	
	var _nivoTheme2 = _interopRequireDefault(_nivoTheme);
	
	var _sumObject = __webpack_require__(133);
	
	var _sumObject2 = _interopRequireDefault(_sumObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerStyle = { height: 200 };
	var colorBy = function colorBy(d) {
	    return _constants.featureColors[d.indexValue];
	};
	var margin = {
	    top: 0,
	    right: 0,
	    bottom: 40,
	    left: 0
	};
	var axisLeft = {
	    tickSize: 0,
	    tickPadding: 10
	};
	var axisBottom = {};
	
	var FeatureBar = function FeatureBar(_ref) {
	    var feature = _ref.feature;
	
	
	    var total = (0, _sumObject2.default)(_features2.default.aggs[feature]);
	    var data = _constants.featureKeys.map(function (key) {
	        var _ref2;
	
	        var value = _features2.default.aggs[feature][key];
	        var percent = Math.round(value * 100 / total);
	        return _ref2 = { id: key }, _ref2[feature] = percent || 0, _ref2;
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { style: containerStyle },
	        _react2.default.createElement(_bar.ResponsiveBar, {
	            layout: 'vertical',
	            padding: 0.3,
	            margin: margin,
	            colors: _constants.colorRange,
	            labelFormat: function labelFormat(v) {
	                return v + '%';
	            },
	            colorBy: colorBy,
	            data: data,
	            keys: [feature],
	            labelsTextColor: 'inherit:darker(1.6)',
	            enableGridX: false,
	            enableGridY: false,
	            isInteractive: false,
	            animate: false,
	            axisLeft: axisLeft,
	            axisBottom: axisBottom,
	            theme: _nivoTheme2.default,
	            indexBy: 'id'
	        })
	    );
	};
	
	FeatureBar.propTypes = {
	    feature: _propTypes2.default.string.isRequired
	};
	
	exports.default = FeatureBar;
	module.exports = exports['default'];

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	module.exports = {"keys":["Server-Side Rendering","Code Splitting","Optimistic Updates","Hot Module Reloading","Time-Travel Debugging","Real-Time Operations","Dead Code Elimination","Progressive Enhancement","Service Workers","Offline Usage"],"aggs":{"Real-Time Operations":{"Nice-to-have, but not important":8481,"Major feature":7834,"I don't know what that is":3451,"Vital feature":2250,"Not needed":1476},"Service Workers":{"Nice-to-have, but not important":10125,"Major feature":6238,"I don't know what that is":3548,"Not needed":2090,"Vital feature":1498},"Dead Code Elimination":{"Nice-to-have, but not important":9639,"Major feature":8264,"Vital feature":3034,"I don't know what that is":1612,"Not needed":981},"Optimistic Updates":{"Nice-to-have, but not important":10202,"Major feature":5712,"I don't know what that is":4550,"Not needed":1853,"Vital feature":1217},"Progressive Enhancement":{"Nice-to-have, but not important":7766,"Major feature":5934,"Not needed":5297,"Vital feature":2721,"I don't know what that is":1780},"Code Splitting":{"Nice-to-have, but not important":9138,"Major feature":9045,"Vital feature":2722,"I don't know what that is":1711,"Not needed":929},"Hot Module Reloading":{"Nice-to-have, but not important":8703,"Major feature":7798,"Vital feature":4084,"I don't know what that is":1608,"Not needed":1358},"Time-Travel Debugging":{"Nice-to-have, but not important":11465,"Major feature":5460,"I don't know what that is":2923,"Not needed":2304,"Vital feature":1369},"Server-Side Rendering":{"Nice-to-have, but not important":11197,"Major feature":6185,"Not needed":2920,"Vital feature":1732,"I don't know what that is":1211},"Offline Usage":{"Nice-to-have, but not important":10676,"Major feature":6639,"Not needed":3526,"Vital feature":1982,"I don't know what that is":676}},"others":{"doc_count_error_upper_bound":5,"sum_other_doc_count":444,"buckets":[{"key":"Accessibility","doc_count":15},{"key":"PWA","doc_count":7},{"key":"na","doc_count":6},{"key":"Performance","doc_count":5},{"key":"AOT","doc_count":3},{"key":"\n\n\n","doc_count":2},{"key":"\n\n\n\n","doc_count":2},{"key":"#","doc_count":2},{"key":"'","doc_count":2},{"key":"??","doc_count":2},{"key":"AMP","doc_count":2},{"key":"Accessible","doc_count":2},{"key":"Dunno","doc_count":2},{"key":"HTTP2","doc_count":2},{"key":"No runtime exceptions","doc_count":2},{"key":"WebAssembly","doc_count":2},{"key":"accessibility","doc_count":2},{"key":"pwa","doc_count":2},{"key":"\n\n\n\n\n","doc_count":1},{"key":"   ","doc_count":1}]}}

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _sum = __webpack_require__(191);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sumObject = function sumObject(o) {
	  return (0, _sum2.default)(Object.keys(o).map(function (k) {
	    return o[k];
	  }));
	};
	
	exports.default = sumObject;
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(11);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _TextBlock = __webpack_require__(25);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _getPageTitle = __webpack_require__(19);
	
	var _getPageTitle2 = _interopRequireDefault(_getPageTitle);
	
	var _features = __webpack_require__(279);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _FeatureBar = __webpack_require__(427);
	
	var _FeatureBar2 = _interopRequireDefault(_FeatureBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var text = '\nWhich features do developers value the most in a JavaScript\napp?\n';
	
	var Features = function Features() {
	    return _react2.default.createElement(
	        _reactDocumentTitle2.default,
	        { title: (0, _getPageTitle2.default)('Features') },
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_TextBlock2.default, { text: text }),
	            _features2.default.keys.map(function (feature) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'block block--chart', key: feature },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'block__title' },
	                        feature
	                    ),
	                    _react2.default.createElement(_FeatureBar2.default, { feature: feature })
	                );
	            })
	        )
	    );
	};
	
	exports.default = Features;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-features-js-74c165ef291097f62e68.js